"use strict";

exports.__esModule = true;
exports.number = void 0;

var _util = require("../../util");

var number = (0, _util.wrapSyncFunc)(function (rule, value) {
  if (typeof value === 'number') {
    return Number.isFinite(value);
  }

  if (typeof value !== 'string' || value === '') {
    return;
  }

  return Number.isFinite(+value);
});
exports.number = number;